import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { WrenchIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const developerToolsDefinition: SmartSignalDefinition<{ developer_tools?: IdEventV4['developer_tools'] }> = {
  key: 'developer-tools',
  label: 'Developer tools',
  extract: (e) => ({ developer_tools: e.developer_tools }),
  icon(e) {
    const p = this.extract(e)?.developer_tools
    return (
      <WrenchIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.developer_tools
    return p === true
  },
  isWeb: () => true,
  isMobile: () => true,
  searchFor: '"developer_tools":',
  documentationHash: '#developer-tools-detection',
  urlParamKey: IdentificationUrlKeys.DeveloperTools,
}
